"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDateRange = exports.parseDateTime = exports.parseDateStr = exports.parseTimeStr = exports.getCurrentDate = exports.getCurrentTime = void 0;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
function getCurrentTime() {
    return (0, moment_1.default)().format(TIME_FORMAT);
}
exports.getCurrentTime = getCurrentTime;
function getCurrentDate() {
    return (0, moment_1.default)().format('YYYY년 M월 D일');
}
exports.getCurrentDate = getCurrentDate;
function parseTimeStr(timeStr) {
    var parsed = (0, moment_1.default)(timeStr, TIME_FORMAT).format('LLL');
    if (lodash_1.default.isEqual(parsed, 'Invalid date')) {
        return timeStr;
    }
    return parsed;
}
exports.parseTimeStr = parseTimeStr;
function parseDateStr(dateFormat, dateStr) {
    var parsed = (0, moment_1.default)(dateStr, dateFormat).format('LL');
    if (lodash_1.default.isEqual(parsed, 'Invalid date')) {
        return dateStr;
    }
    return parsed;
}
exports.parseDateStr = parseDateStr;
function parseDateTime(date) {
    var parsed = (0, moment_1.default)(date).format('LLL');
    if (lodash_1.default.isEqual(parsed, 'Invalid date')) {
        return '';
    }
    return parsed;
}
exports.parseDateTime = parseDateTime;
function toDateRange(start, end) {
    var startDate = (0, moment_1.default)(start);
    var endDate = (0, moment_1.default)(end);
    if (startDate.year() === endDate.year()) {
        return "".concat(startDate.format('YYYY-MM-DD'), " ~ ").concat(endDate.format('MM-DD'));
    }
    return "".concat(startDate.format('YYYY-MM-DD'), " ~ ").concat(endDate.format('YYYY-MM-DD'));
}
exports.toDateRange = toDateRange;
//# sourceMappingURL=TimeUtils.js.map